/* eslint-disable jsx-a11y/alt-text */
import {
  Typography,
  useMediaQuery,
  useTheme,
  Grid,
  Button,
} from "@mui/material";
import PlaceIcon from "@mui/icons-material/Place";
import MailIcon from "@mui/icons-material/Mail";
import StayCurrentPortraitIcon from "@mui/icons-material/StayCurrentPortrait";
import Iconify from "../iconify";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

const BottomTab = () => {
  const navigate = useNavigate();
  const theme = useTheme<any>();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const isSmallScreen = useMediaQuery<any>(theme.breakpoints.down("sm"));
  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  let year = new Date().getFullYear();
  const smoothScroll = (target: string) => {
    const $target = document.querySelector(target);
    if ($target) {
      window.scrollTo({
        top: $target.getBoundingClientRect().top + window.pageYOffset,
        behavior: "smooth",
      });
    }
  };
  return (
    <>
      <div style={Styles.main}>
        <Grid container spacing={0} alignItems="center" justifyContent="center">
          <Grid item xs={12} sm={6} md={1} style={{}}></Grid>
          <Grid item xs={12} sm={6} md={2} style={{}}>
            <div style={Styles.body}>
              <img
                style={Styles.logoImage}
                src={require("../../assets/image/eventprix-logo-main.png")}
              />
              <Typography style={{ color: "#fff" }}>
                EventPrix provides the tools for seamless event management, online ticketing, and attendee engagement. Your success is our business.
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} sm={6} md={1}></Grid>
          <Grid item xs={12} sm={6} md={2}>
            <div
              style={{
                flexDirection: "column",
                height: isSmallScreen ? 120 : 200,
              }}
            >
              <Typography
                variant="h4"
                color={"#fff"}
                style={{ height: isSmallScreen ? 40 : 50 }}
              >
                Support
              </Typography>
              <a
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "8px",
                }}
                onClick={(e: any) => {
                  e.preventDefault();
                  smoothScroll("#aboutus");
                  toggleDrawer();
                }}
              >
                <Button
                  variant="text"
                  onClick={() => {
                    navigate(`/home`);
                  }}
                  sx={{
                    color: "#fff",
                    fontSize: 18,
                    fontWeight: "300",
                    padding: 0,
                  }}
                >
                  <Iconify
                    sx={{
                      width: "23px !important",
                      height: "23px !important",
                      color: "#fff",
                      marginRight: "5px",
                    }}
                    icon="mdi:about-circle-outline"
                  />{" "}
                  About Us
                </Button>
              </a>
              <Button
                variant="text"
                onClick={() => {
                  navigate(`/contact-us`);
                }}
                sx={{
                  color: "#fff",
                  fontSize: 18,
                  fontWeight: "300",
                  padding: 0,
                }}
              >
                <Iconify
                  sx={{
                    width: "23px !important",
                    height: "23px !important",
                    color: "#fff",
                    marginRight: "5px",
                  }}
                  icon="ic:outline-contact-support"
                />{" "}
                Contact Us
              </Button>
                <br/>
                 
                 <Button
                variant="text"
                onClick={() => {
                  navigate(`/privacy-and-policy`);
                }}
                sx={{
                  color: "#fff",
                  fontSize: 18,
                  fontWeight: "300",
                  padding: 0,
                }}  
              >
                <Iconify
                  sx={{
                    width: "23px !important",
                    height: "23px !important",
                    color: "#fff",
                    marginRight: "5px",
                  }}
                  icon="mdi:lock-outline"
                />{" "}
                Privacy Policy
              </Button>
            </div>
          </Grid>
         
          <Grid item xs={12} sm={6} md={3} style={{paddingTop: isSmallScreen ? 25 :  0}}>
            <div
              style={{
                flexDirection: "column",

                height: isSmallScreen ? 200 : 200,
                justifyContent: "center",
              }}
            >
              <Typography
                variant="h4"
                color={"#fff"}
                style={{ height: isSmallScreen ? 25 : 50 }}
              >
                Contact Us
              </Typography>

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  height: isSmallScreen ? 50 : 60,
                }}
              >
                <PlaceIcon
                  style={{
                    color: "#fff",
                    marginRight: 5,
                    height: isSmallScreen ? 18 : 18,
                  }}
                />
                <Typography style={{ color: "#fff" }}>
                  1904 Donetto Dr, Leander, TX 78641
                </Typography>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  height: isSmallScreen ? 50 : 60,
                }}
              >
                <MailIcon
                  style={{
                    color: "#fff",
                    marginRight: 5,
                    height: isSmallScreen ? 18 : 18,
                  }}
                />
                <Typography style={{ color: "#fff" }}>
                  contact@eventprix.com
                </Typography>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  height: isSmallScreen ? 50 : 60,
                }}
              >
                <StayCurrentPortraitIcon
                  style={{
                    color: "#fff",
                    marginRight: 5,
                    height: isSmallScreen ? 18 : 18,
                  }}
                />
                <Typography style={{ color: "#fff" }}>
                  737-587-0412
                </Typography>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={6} md={3} style={{}}>
            <div
              style={{
                flexDirection: "column",

                height: isSmallScreen ? 200 : 200,
                justifyContent: "center",
              }}
            >
              <Typography
                variant="h4"
                color={"#fff"}
                style={{ height: isSmallScreen ? 40 : 50 }}
              >
                Download APP
              </Typography>

              <img
                style={{
                  flexGrow: 3,
                  height: 50,
                  width: 180,
                  marginBottom: 20,
                  borderRadius: 10,
                }}
                src={require("../../assets/image/Screenshot 2023-09-15 110205.png")}
              />
              <img
                style={{
                  flexGrow: 3,
                  height: 50,
                  width: 180,
                  marginBottom: 20,
                  borderRadius: 10,
                }}
                src={require("../../assets/image/Screenshot 2023-09-15 113850.png")}
              />
            </div>
          </Grid>
        </Grid>
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexWrap: "wrap",
          width: "100%",
          height: isSmallScreen ? 90 : 80,
          backgroundColor: "#000",
          padding: 15,
        }}
      >
        <p
          style={{
            color: "#fff",
          }}
        >
          Copyright© {year} EventPrix LLC. All Rights Reserved.
        </p>
      </div>
    </>
  );
};

export default BottomTab;

const Styles: any = {
  main: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: "80px 30px 80px 30px",
    flexWrap: "wrap",
    width: "100%",
    marginTop: "25px",
    backgroundColor: "#A58E74",
  },
  body: {
    flexDirection: "column",

    justifyContent: "center",
    alignItems: "center",
    height: "isSmallScreen" ? 160 : 300,
  },
  logoImage: { flexGrow: 3, height: 40, width: 80, marginBottom: 10 },
};
